import { format } from 'date-fns';

/** How the security page's cards show a date: day first, a dash when there is none. */
export const formatDate = (value: string | null | undefined) =>
  value ? format(new Date(value), 'dd/MM/yyyy') : '—';
